import { Button, Dialog, IconButton, Text, Tooltip } from '@radix-ui/themes';
import { UserPlus } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MultiSelect from '../../elements/MultiSelect';

const AddGroupMember = ({
  onSubmit,
  accessGroup,
  users,
  loading,
}: {
  onSubmit: (id: string, invites: string[]) => Promise<void>;
  accessGroup: { id: string; members: { id: string }[] };
  users: { id: string; firstName: string; lastName: string }[];
  loading: boolean;
}) => {
  const { t } = useTranslation();
  const [usersInvite, setUsersInvite] = useState<string[]>([]);
  const [options, setOptions] = useState<{ label: string; value: string }[]>([]);
  const [groupMemberIds, setGroupMemberIds] = useState<string[]>([]);

  const handleSubmit = () => {
    onSubmit(accessGroup.id, usersInvite).then(() => {});
  };

  useEffect(() => {
    const memberIds: string[] = [];

    accessGroup?.members.map((user) => {
      memberIds.push(user.id);
    });

    setGroupMemberIds(memberIds);
  }, [accessGroup]);

  useEffect(() => {
    const memberOptions: { label: string; value: string }[] = [];

    users?.map((user) => {
      if (!groupMemberIds.includes(user.id)) {
        memberOptions.push({ label: `${user.firstName} ${user.lastName}`, value: user.id });
      }
    });

    // TODO: Replace with backend sorting
    memberOptions.sort((a, b) => a.label.localeCompare(b.label));

    setOptions(memberOptions);
  }, [users, accessGroup, groupMemberIds]);

  return (
    <Dialog.Root onOpenChange={() => setUsersInvite([])}>
      <Tooltip content={<Text size="3">{t('settings.accessGroupDialogs.addGroupMembers.tooltip')}</Text>}>
        <Dialog.Trigger>
          <IconButton variant="ghost" color="gray" highContrast className="m-0">
            <UserPlus size={20} />
          </IconButton>
        </Dialog.Trigger>
      </Tooltip>
      <Dialog.Content aria-describedby={undefined}>
        <Dialog.Title>{t('settings.accessGroupDialogs.addGroupMembers.dialogTitle')}</Dialog.Title>
        <MultiSelect
          options={options}
          onChange={setUsersInvite}
          placeholder={t('settings.accessGroupDialogs.addGroupMembers.placeholder')}
          className="w-full my-2"
        />

        <div className="flex flex-row justify-between w-full pt-4">
          <Dialog.Close>
            <Button size="3" color="gray" variant="soft" className="w-full">
              {t('settings.accessGroupDialogs.addGroupMembers.cancelButton')}
            </Button>
          </Dialog.Close>
          <Dialog.Close>
            <Button
              size="3"
              className="w-full"
              disabled={usersInvite.length === 0 || loading}
              loading={loading}
              onClick={handleSubmit}
            >
              {t('settings.accessGroupDialogs.addGroupMembers.addButton')}
            </Button>
          </Dialog.Close>
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default AddGroupMember;
